import React from 'react';
import './index.scss';
const hex_default = "#ffffff"
class Icon extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
        const {icon,background} = this.props;
		return (
			<div className="icon" style={{backgroundColor:background?background:hex_default}}>
				<img src={icon} />
			</div>
		);
	}
}

export default Icon;



// WEBPACK FOOTER //
// ./src/screens/LoginBot/Icon.js